export default {
  //授课互评
  SKCommentList: '',
  //互评详情
  SKCommentDetails: '',
  //互评添加
  SKCommentAdd: '',
  //互评编辑
  SKCommentEdit: '',
}



// WEBPACK FOOTER //
// ./src/store/give-course/comment/states.js